"use client";

import React from "react";
import DecorationLine from "@/components/global/ui/DecorationLine";
import { cn } from "@/lib/utils";

/** Green marquee strip under the hero: pixel arrow + 24px Funnel text, 68px tall, framed by two dividers. */
export default function Ticker({ items, className }: { items?: string[]; className?: string }) {
  const texts = (items ?? []).filter(Boolean);
  if (!texts.length) return null;

  const repeats = Math.ceil(30 / texts.length);
  const entries = Array.from({ length: repeats }).flatMap((_, r) =>
    texts.map((text, i) => (
      <div key={`${r}-${i}`} className="flex shrink-0 items-center gap-[4rem] pr-[4rem] lg:gap-[5rem] lg:pr-[5rem]">
        <svg className="h-[1.5rem] w-[2.125rem] shrink-0" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path
            d="M0 8h16v4H0V8zm16-8h4v4h-4V0zm0 8h4v4h-4V8zm0 8h4v4h-4v-4zm4-12h4v4h-4V4zm0 8h4v4h-4v-4zm4-4h4v4h-4V8z"
            fill="currentColor"
          />
        </svg>
        <p className="mb-0 whitespace-nowrap font-funnel text-[2.5rem] leading-none lg:text-[3rem]">{text}</p>
      </div>
    )),
  );

  return (
    <div className={cn("relative", className)}>
      <DecorationLine className="top-0" orientation="horizontal" style="dark" />
      <div className="relative overflow-clip bg-[#D9F9B9] py-[2.25rem] text-[#0A1A1D] lg:py-[2.75rem]">
        <div
          className="inline-flex items-center will-change-transform"
          style={{ animation: "scrollRight 45s linear infinite" }}
        >
          {entries}
        </div>
      </div>
      <DecorationLine className="bottom-0" orientation="horizontal" style="dark" />
    </div>
  );
}
